// One-time migration of legacy "Change environment" values to their Google
// Cloud (GC) equivalents. Users who logged in before the GC server switch still
// hold the old value in localStorage; without this they stay pinned to the old
// API endpoints (detectEnvironment maps the legacy values to the old hosts).
//
//   "production"  -> "prod-gc"   (api.greenpraxis.com     -> api-prod.greenpraxis.com)
//   "development" -> "test-gc"   (api-dev.greenpraxis.com -> api-test.greenpraxis.com)
//
// Auth is unaffected: usesProdAuth() treats "production" and "prod-gc" alike,
// and "development"/"test-gc" alike (see firebase.js).
//
// MUST run before any module reads localStorage["environment"] — it is invoked
// synchronously in index.js, before the deferred import("./App").
const LEGACY_ENVIRONMENT_MAP = {
  production: "prod-gc",
  development: "test-gc",
};

export const migrateLegacyEnvironment = () => {
  const current = localStorage.getItem("environment");
  const migrated = LEGACY_ENVIRONMENT_MAP[current];
  if (migrated) {
    localStorage.setItem("environment", migrated);
  }
};
